// Discriminator sent on the polymorphic Booking payload to mark a closed-day booking. The generated
// client types it as a plain `string`, so it is not inferred — we set it explicitly when building a
// request. Shared occurrence constants live in `../Bookings/shared`.
export const CLOSED_DAY_BOOKING_TYPE = 'CLOSED_DAY' as const;

// A Closed day is always a SingleOccurrence (never recurring). A full-day closure is stored as the
// whole calendar day: 00:00 to 23:59. The 23:59 is this frontend's own end-of-day marker — the
// backend persists a SingleOccurrence as two plain LocalDateTimes with no end-of-day semantics, so
// these values are meaningful only to this module. A partial closure carries explicit times instead.
// These two sentinels also drive full-vs-partial detection when a stored booking is loaded (see
// isFullDayWindow in closedDayTime.ts).
export const FULL_DAY_START_TIME = '00:00' as const;
export const FULL_DAY_END_TIME = '23:59' as const;

// Default end time pre-filled when switching a closure to partial-day, so only the start needs picking.
export const DEFAULT_PARTIAL_END_TIME = FULL_DAY_END_TIME;
